import { CommonModule } from "@angular/common";
import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { AbstractControl, ControlContainer, FormArray, FormControl, FormGroup, FormGroupDirective, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatCheckboxChange, MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectChange, MatSelectModule } from "@angular/material/select";
import { map, Observable, of, Subscription } from "rxjs";
import { AddressCategory } from "../../../dashboard/models/address-category";
import { AppointmentType } from "../../../dashboard/models/appointment-types";
import { ProviderAddress } from "../../../dashboard/models/provider-adddress";
import { HOME_ADDRESS_CATEGORY, TripRequestAddressCategoryModel } from "../../../dashboard/models/trip-request-models";
import { OTHER_ADDRESS_CATEGORY } from "../../../dashboard/profile/state/profile-model";
import { TripRequestService } from "../../../dashboard/services/trip-request.service";
import { ReadonlySelectDirective } from "../../../shared/directives/readonly-select.directive";
import { TouchedErrorStateMatcher } from "../../../shared/other/touched-form-error-state-matcher";
import { LookupsService } from "../../../shared/services/lookups-service";
import { SelectedProfileService } from "../../../shared/services/selected-profile.service";
import { State } from "../../../state/lookups/lookups-model";
import { TripRequestFormFactory } from "../../shared/trip-request-form.factory";
import { TripRequestFormService } from "../../shared/trip-request-form.service";
import { WidgetComponent } from "../../widget/widget.component";

@Component({
  selector: 'app-trip-location',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatSelectModule,
    MatIconModule,
    MatAutocompleteModule,
    ReadonlySelectDirective
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './trip-location.component.html',
  styleUrl: './trip-location.component.scss',
})

export class TripLocationComponent implements OnInit, OnDestroy {

  private postTripRequestFormDir = inject(FormGroupDirective);
  private dialog = inject(MatDialog);
  private lookupService = inject(LookupsService);
  private tripRequestService = inject(TripRequestService);
  private tripRequestFormService = inject(TripRequestFormService);
  private tripRequestFormFactory = inject(TripRequestFormFactory);
  private selectedProfileService = inject(SelectedProfileService);
  tripRequest!: FormGroup;
  tripAddressFr!: FormArray;
  appointmentDatesFr!: FormArray;
  addressCategoryList$!: Observable<AddressCategory[]>;
  recipientaddressCategories$!: Observable<TripRequestAddressCategoryModel[]>;
  appointmentTypesList$!: Observable<AppointmentType[]>;
  addressCount= 0;
  providerAddress$: Observable<ProviderAddress[]>[] = [];
  showAppointmentType = false;
  matcher = new TouchedErrorStateMatcher();
  filteredAddress$: Observable<string[]>[] = [];
  stateList: State[] = [];
  private stateSub!: Subscription;
  readonly homeAddressCategory = HOME_ADDRESS_CATEGORY;


  ngOnInit(): void {
      this.tripRequest = this.postTripRequestFormDir.form.get("tripRequest") as FormGroup;
      this.tripAddressFr = this.tripRequest.get("tripAddresses") as FormArray;
      this.appointmentDatesFr = this.tripRequest.get("tripAppointments") as FormArray;
      this.setAddressSearchList();
      this.appointmentTypesList$! = this.lookupService.getAppointmentTypes();
      this.recipientaddressCategories$! = this.tripRequestService.getTripRequestAddressCategories(this.selectedProfileService.selectedRecipientId()!);
      this.addressCategoryList$! = this.lookupService.getProfileAddressCategories();

      this.stateSub = this.lookupService.getStates().subscribe(data =>  {
          this.stateList = data;
       });
  }

  get ShowRoundTrip() : FormControl {
    return this.tripRequest.get("showRoundTrip") as FormControl;
  }

  setAddressSearchList() {
      this.tripAddressFr.controls.forEach((control: AbstractControl, i) => {
          this.providerAddress$.push(of([]));
          this.filteredAddress$[i] = this.tripRequestFormService.getSearchAddressList(control as FormGroup);
      });
  }

  addAdditionalStop() {
      this.tripRequest.get('showRoundTrip')?.setValue(false);
      this.tripRequest.get('isRoundTrip')?.setValue(false);
      const newStop = this.tripRequestFormFactory.getTripAddressFg(this.tripAddressFr.controls.length);
      this.tripAddressFr.push(newStop);
      this.tripAddressFr.at(this.tripAddressFr.controls.length-1).get('seqNo')?.setValue(this.tripAddressFr.controls.length);
      this.providerAddress$.push(of([]));
      this.filteredAddress$[this.tripAddressFr.controls.length-1] = this.tripRequestFormService.getSearchAddressList(newStop);

  }

  onAddressSelected(event: MatAutocompleteSelectedEvent, index: number): void {
    this.tripRequestFormService.validateSelectedAddress(this.tripAddressFr, event.option.value, index);
    this.tripAddressFr.at(index).get('isManualAddress')?.setValue(true);
    this.tripAddressFr.at(index).get('isMapAddress')?.setValue(false);
  }

  onAddressEntered(index: number) {
      this.tripAddressFr.at(index).get('isManualAddress')?.setValue(true);
      this.tripAddressFr.at(index).get('isMapAddress')?.setValue(false);
  }

  onAppointmentTypeChange(event: MatSelectChange): void {
      this.appointmentTypesList$.pipe(
        map(items => items.find(item => item.id === event.value)),
      ).subscribe(item => {
          this.showAppointmentType = item?.appointmentTypeName.trim() === 'Other'
          this.tripRequestFormService.selectedAppointmentType = item?.appointmentTypeName.trim()!;
          this.tripRequest.get('appointmentType')?.reset();
      });
  }

  IsOtherCategory(selectedCategory : string) : boolean {
      return Number(selectedCategory) === OTHER_ADDRESS_CATEGORY
  }

  getSubRowClass(addressIndex: number): string {
    if (this.tripRequest.get('showRoundTrip')?.value === true) {
        if (this.tripAddressFr.length === addressIndex + 1) {
          return 'round-trip-container'
        }
        else {
          return 'right-bottom-container'
        }
      }
      return 'right-bottom-container'
  }

  onSelectAddressfromMap(addressIndex: number): void {
    const dialogRef = this.dialog.open(WidgetComponent, {
        width: '80%',
        height: window.innerHeight > 800 ? '70%' : '90%'
      });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
          if (!this.tripAddressFr.at(addressIndex-1).get('locationMannualEntry')?.value) {
              this.tripAddressFr.at(addressIndex-1).get('selectedAddress')?.setValue('');
          }
          if (!this.tripAddressFr.at(addressIndex).get('locationMannualEntry')?.value) {
              this.tripAddressFr.at(addressIndex).get('selectedAddress')?.setValue('');
          }

          if (this.tripAddressFr.at(addressIndex-1).get('addressCategoryId')?.value !== HOME_ADDRESS_CATEGORY) {
            this.tripAddressFr.at(addressIndex-1).get('address')?.setValue(result.startingAddress.trim());
            this.tripAddressFr.at(addressIndex-1).get('isManualAddress')?.setValue(false);
            this.tripAddressFr.at(addressIndex-1).get('isMapAddress')?.setValue(true);
          }

          if (this.tripAddressFr.at(addressIndex).get('addressCategoryId')?.value !== HOME_ADDRESS_CATEGORY) {
            this.tripAddressFr.at(addressIndex).get('address')?.setValue(result.endingAddress.trim());
            this.tripAddressFr.at(addressIndex).get('isManualAddress')?.setValue(false);
            this.tripAddressFr.at(addressIndex).get('isMapAddress')?.setValue(true);
          }
      }
    });
  }

  onEnterLocationManual(frmControl: AbstractControl | null) {
      frmControl!.setValue(true);
  }

  onEnterExistingLocation(frmControl: AbstractControl | null) {
      frmControl!.setValue(false);
  }

  onRoundTripChange($event: MatCheckboxChange) {
    this.tripRequest.get('showAdditionalStop')?.setValue(!$event.checked)
  }

  removeStopping(addressIndex: number) {
      this.tripAddressFr.removeAt(addressIndex);
      if (this.tripAddressFr.length == 2)
      {
        this.tripRequest.get('showRoundTrip')?.setValue(true);
      }
      this.providerAddress$.splice(addressIndex, 1);
      this.filteredAddress$.splice(addressIndex, 1);
  }

  onProviderAddressChange(event: MatSelectChange, addressIndex: number ) {
      this.tripAddressFr.at(addressIndex).get('address')?.setValue(event.value);
      this.tripAddressFr.at(addressIndex).get('isManualAddress')?.setValue(false);
      this.tripAddressFr.at(addressIndex).get('isMapAddress')?.setValue(false);
  }

  onAddressCategoryChange(event: MatSelectChange, addressIndex: number ) {
    this.tripAddressFr.at(addressIndex).get('otherCategoryType')?.setValue(event.value);
    this.providerAddress$[addressIndex] = this.tripRequestService
                                          .getTripAndSavedAddresses(this.selectedProfileService.selectedRecipientId()!,
                                          this.selectedProfileService.selectedCountyCode()!,event.value);

    if (event.value == HOME_ADDRESS_CATEGORY 
        || !this.tripAddressFr.at(addressIndex).get('isManualAddress')?.value
        || !this.tripAddressFr.at(addressIndex).get('isMapAddress')?.value) {
        this.tripAddressFr.at(addressIndex).get('address')?.setValue('');
        this.tripAddressFr.at(addressIndex).get('isManualAddress')?.setValue(false);
        this.tripAddressFr.at(addressIndex).get('isMapAddress')?.setValue(false);
    }
  }

  getIsRoundTripControl(): FormControl {
    return this.tripRequest.get('isRoundTrip') as FormControl;
  }

  getAddressCaption(index: number) : string {
    if (index === 0) {
      return "Enter Starting Address"
    }
    else if (index === this.tripAddressFr.controls.length -1) {
      return "Enter Destination Address"
    }
    return "Enter Stoping Address";
  }

  hasError(controlName: string, errorName: string): boolean {
      const control: AbstractControl | null = this.tripRequest.get(`${controlName}`);
      return !!control && control.hasError(errorName) && (control.dirty || control.touched);
  }

  ngOnDestroy(): void {
    if (this.stateSub) {
      this.stateSub.unsubscribe();
    }
  }

}
